module.exports = function fillRegion(fillColor, region) {
	if(region) {
		region.options.set('fillColor', fillColor);
		region.options.set('strokeWidth', 0);
		region.properties.set('hintContent', null);
	}

	return region;
};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/contacts/fn/fillRegion.js
 **/